import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { AlertTriangle, Clock, Users, XCircle, X } from "lucide-react";
import "./Closejobmodal.css";
import "components/common/ModalSuccesUpdate/ModalSuccesUpdate.css";

interface CloseJobModalProps {
  show: boolean;
  jobTitle?: string;
  isClosing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CloseJobModal: React.FC<CloseJobModalProps> = ({
  show,
  jobTitle,
  isClosing,
  onCancel,
  onConfirm,
}) => (
  <Modal
    show={show}
    onHide={() => !isClosing && onCancel()}
    centered
    contentClassName="dm-content"
    backdropClassName="dm-backdrop"
  >
    <button
      type="button"
      className="dm-close"
      onClick={onCancel}
      disabled={isClosing}
      aria-label="Close"
    >
      <X size={18} />
    </button>

    <Modal.Body className="dm-body" style={{ paddingBottom: 16 }}>
      <div className="dm-icon" style={{ background: '#fef2f2', color: '#dc2626', boxShadow: '0 0 0 8px rgba(220, 38, 38, 0.08)' }}>
        <AlertTriangle size={26} />
      </div>

      <h2 className="dm-title">Close Position</h2>
      <p className="dm-text" style={{ marginBottom: 20 }}>
        Are you sure you want to close <strong>"{jobTitle || "this job"}"</strong>? This will
        stop accepting new applications.
      </p>

      <div className="cj-notice">
        <div className="cj-notice-head">
          <AlertTriangle size={15} />
          Active candidates will be affected
        </div>
        <ul className="cj-notice-list">
          <li className="cj-notice-item">
            <Clock size={15} />
            <span>Applicants will no longer be able to apply once this position is closed.</span>
          </li>
          <li className="cj-notice-item">
            <Users size={15} />
            <span>Existing candidate records and interview progress will remain available.</span>
          </li>
        </ul>
      </div>
    </Modal.Body>

    <Modal.Footer className="dm-footer">
      <button
        type="button"
        className="dm-btn dm-btn-cancel"
        onClick={onCancel}
        disabled={isClosing}
      >
        Keep Open
      </button>
      <button
        type="button"
        className="dm-btn dm-btn-danger"
        onClick={onConfirm}
        disabled={isClosing}
      >
        {isClosing ? (
          <>
            <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
            <span>Closing...</span>
          </>
        ) : (
          <>
            <XCircle size={16} />
            Close Position
          </>
        )}
      </button>
    </Modal.Footer>
  </Modal>
);

export default CloseJobModal;

/* ---------- Usage: replace your <Modal show={!!jobToClose} ...> block with ----------

<CloseJobModal
  show={!!jobToClose}
  jobTitle={jobToClose?.title}
  isClosing={isClosing}
  onCancel={() => setJobToClose(null)}
  onConfirm={handleConfirmClose}
/>
*/